import React from "react";

const Settings = () => {
  return (
    <div className="p-10 text-center">
      <h1 className="text-2xl font-semibold">Settings</h1>
      <p>Update your preferences here.</p>
    </div>
  );
};

export default Settings;